// extracted by mini-css-extract-plugin
module.exports = {"ProductRecommend":"ProductRecommend_ProductRecommend__mZSdD","ef-box":"ProductRecommend_ef-box__89_KW"};